import RestService from '../services/rest';

async function getListAndCountAllNotificationEmail(limit, skip, search, orderBy, field, firstRun = false) {
  const firstRunParameters = (firstRun) ? `&firstRun=${firstRun}` : '';
  return RestService.getAuthenticated(
    `panel/notificationEmail/listAndCountAll?limit=${limit}&skip=${skip}&search=${search}&orderBy=${orderBy}&field=${field}${firstRunParameters}`,
  );
}

async function createNotificationEmail(parameters) {
  return RestService.postAuthenticated('panel/notificationEmail/create', parameters);
}

async function updateNotificationEmail(parameters) {
  return RestService.putAuthenticated('panel/notificationEmail/update', parameters);
}

async function updateStatusEmail(id, status) {
  return RestService.putAuthenticated('panel/notificationEmail/updateStatus', { id, status });
}

async function deleteEmailNotification(id) {
  return RestService.postAuthenticated('panel/notificationEmail/delete', { id });
}

export default {
  getListAndCountAllNotificationEmail,
  createNotificationEmail,
  updateNotificationEmail,
  updateStatusEmail,
  deleteEmailNotification,
};
